<template>
    <el-table
        :data="data"
        ref="table"
        empty-text="無資料"
        size="small"
        style="width: 100%"
        class="accounting-annual-tax-service-fee-statement-sub-table"
        show-summary
        :summary-method="getTableSummaries"
        :default-sort="{ prop: 'payoo', order: 'ascending' }"
    >
        <el-table-column prop="systemNo" label="來源勞報單號" width="110">
            <template slot-scope="scope">
                <el-button type="text" style="font-weight: bold; padding: 0; font-size: 9pt" @click="$emit('open', scope.row.sno)">
                    {{ scope.row.systemNo }}
                </el-button>
            </template>
        </el-table-column>
        <el-table-column prop="nam" label="摘要" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="payoo" label="來源請款單號" width="110">
            <template slot-scope="scope">
                <el-button type="text" style="font-weight: bold; padding: 0; font-size: 9pt" @click="$emit('openPayment', scope.row.paymentSno)">
                    {{ scope.row.payoo }}
                </el-button>
            </template>
        </el-table-column>
        <el-table-column prop="incomeType" label="所得類別" width="80">
            <template slot-scope="scope">
                {{ getIncomeTypeTxt(scope.row.incomeType) }}
            </template>
        </el-table-column>
        <el-table-column prop="serviceType" label="業別代號" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                {{ getServiceTypeTxt(scope.row.serviceType) }}
            </template>
        </el-table-column>
        <el-table-column prop="amt" label="金額" align="right" width="130">
            <template slot-scope="scope">
                <div>
                    <Money :v="scope.row.amt" zero="-" />
                </div>
                <template v-if="scope.row.cny !== 'TWD'">
                    <div>
                        <Money :v="scope.row.originAmt" zero="-" />
                        <span style="margin-left: 5px">{{ scope.row.cny }}</span>
                    </div>
                    <div>匯率：{{ scope.row.cnyRat }}</div>
                </template>
            </template>
        </el-table-column>
        <el-table-column prop="taxAmt" label="稅款" align="right" width="100">
            <template slot-scope="scope">
                <Money :v="scope.row.taxAmt" zero="-" />
            </template>
        </el-table-column>
        <el-table-column prop="realPayAmt" label="所得淨額" align="right" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.amt - scope.row.taxAmt" zero="-" />
            </template>
        </el-table-column>
        <el-table-column prop="gen2Amt" label="代扣二代健保" align="right" width="120">
            <template slot-scope="scope">
                <Money :v="scope.row.gen2Amt" zero="-" />
            </template>
        </el-table-column>
        <el-table-column prop="paY_DAT" label="給付日期" align="center" width="120">
            <template slot-scope="scope">
                <div style="font-weight: bold">
                    {{ scope.row.paY_DAT | dateFormater("YYYY-MM-dd") }}
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import _ from 'lodash';
import { serviceTypeList, serviceType9AList, serviceType9BList } from '@/assets/commonData/options';

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        getIncomeTypeTxt(incomeTypeNum) {
            const s = serviceTypeList.find((x) => x.value === incomeTypeNum);
            return s ? s.type : '';
        },
        getServiceTypeTxt(serviceTypeNum) {
            const allServiceList = serviceType9AList.concat(serviceType9BList);
            const s = allServiceList.find((x) => x.key === serviceTypeNum);
            return s ? `${s.key}：${s.label}` : '無';
        },
        getTableSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            const totalAmount = _.sumBy(data, 'amt');
            const totalTaxAmount = _.sumBy(data, 'taxAmt');
            const totalGen2Amount = _.sumBy(data, 'gen2Amt');

            columns.forEach((column, index) => {
                if (column.property === 'nam') {
                    sums[index] = '總計';
                    return;
                }

                if (column.property === 'amt') {
                    sums[index] = totalAmount !== 0 ? Number(totalAmount).toLocaleString('en') : '-';
                    return;
                }

                if (column.property === 'taxAmt') {
                    sums[index] = totalTaxAmount !== 0 ? Number(totalTaxAmount).toLocaleString('en') : '-';
                    return;
                }

                if (column.property === 'realPayAmt') {
                    const NET = totalAmount - totalTaxAmount;
                    sums[index] = NET !== 0 ? Number(NET).toLocaleString('en') : '-';
                    return;
                }

                if (column.property === 'gen2Amt') {
                    sums[index] = totalGen2Amount !== 0 ? Number(totalGen2Amount).toLocaleString('en') : '-';
                }
            });

            return sums;
        },
    },
};
</script>

<style lang="scss">
.accounting-annual-tax-service-fee-statement-sub-table {
    &::before {
        height: 0 !important;
    }
    .el-table__header-wrapper .el-table-column--selection .cell {
        display: none !important;
    }
    .el-table__footer-wrapper td {
        border-bottom: 0 !important;
    }
}
</style>
